import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const DesktopAppComponent = lazy(() => import('./desktop-app.tsx'));

export const desktopAppRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <DesktopAppComponent />
      </Suspense>
    )
  }
];
